import Swal from 'sweetalert2';
import { get_token } from '@/router';
import HomeNavBar from '@/components/HomeNavBar/HomeNavBar.vue';

export default {
  name: 'PublicOrganizations',
  components: { HomeNavBar },
  data: () => ({
    organizations: [],
    organization: {},
    query: '',
    loading: false,
    joining: false,
    error: '',
    page_request: null,
    page_request_id: 0,
  }),
  computed: {
    is_authenticated() {
      return Boolean(get_token());
    },
    return_path() {
      return this.$route.fullPath;
    },
    personal_registration_route() {
      return { name: 'register_personal', query: { next: this.return_path } }; // NOPMD
    },
    login_route() {
      return { name: 'login', query: { next: this.return_path } }; // NOPMD
    },
    filtered_organizations() {
      const query = String(this.query || '').trim().toLowerCase();
      if (!query) return this.organizations;
      return this.organizations.filter(organization => [
        organization.company_name,
        organization.location,
        organization.type_of_organization,
      ].some(value => String(value || '').toLowerCase().includes(query)));
    },
  },
  mounted() {
    this.load_page();
  },
  beforeUnmount() {
    this.abort_page_request();
  },
  watch: {
    '$route.fullPath': 'load_page',
  },
  methods: {
    load_page() {
      this.abort_page_request();
      this.organization = {};
      this.error = '';
      if (this.$route.name === 'public_organization' && this.$route.params.organization_id) {
        this.load_organization();
      }
      else this.load_organizations();
    },
    abort_page_request() {
      if (this.page_request && this.page_request.readyState !== 4) {
        this.page_request.abort();
      }
      this.page_request = null;
    },
    load_organizations() {
      const request_id = ++this.page_request_id;
      this.loading = true;
      const request = $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/public_organizations/`,
        type: 'GET',
        success: response => {
          if (this.$route.name === 'public_organizations') {
            this.organizations = response.organizations || [];
          }
        },
        error: (xhr, status) => {
          if (status !== 'abort') this.error = xhr.responseJSON?.message || 'Could not load public organisations.';
        },
        complete: () => {
          if (this.page_request_id === request_id) {
            this.loading = false;
            this.page_request = null;
          }
        },
      });
      this.page_request = request;
    },
    load_organization() {
      const organization_id = this.$route.params.organization_id;
      const request_id = ++this.page_request_id;
      this.loading = true;
      const request = $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/public_organization/`,
        type: 'GET',
        data: { organization_id },
        success: response => {
          if (
            this.$route.name === 'public_organization' &&
            String(this.$route.params.organization_id) === String(organization_id)
          ) {
            this.organization = response.organization || {};
          }
        },
        error: (xhr, status) => {
          if (status !== 'abort') this.error = xhr.responseJSON?.message || 'Public organisation not found.';
        },
        complete: () => {
          if (this.page_request_id === request_id) {
            this.loading = false;
            this.page_request = null;
          }
        },
      });
      this.page_request = request;
    },
    open_organization(organization) {
      this.$router.push({
        name: 'public_organization',
        params: { organization_id: organization.id },
      });
    },
    clear_search() {
      this.query = '';
    },
    remember_return_path() {
      sessionStorage.setItem('next', this.return_path);
    },
    join_organization() {
      if (!this.organization?.id || this.joining) return;
      this.joining = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/join_public_organization/`,
        type: 'POST',
        headers: { Authorization: `Token ${get_token()}`, 'Content-Type': 'application/json' },
        data: JSON.stringify({ organization_id: this.organization.id }),
        success: response => {
          const joined = response.organization || this.organization;
          localStorage.setItem('organization_id', joined.id);
          localStorage.setItem('organization_name', joined.company_name || '');
          localStorage.setItem('company_name', joined.company_name || '');
          localStorage.setItem('active_profile_type', 'business');
          Swal.fire({ icon: 'success', title: 'Organisation joined', text: response.message, timer: 1800, showConfirmButton: false })
            .then(() => { window.location = '/organisation/'; });
        },
        error: xhr => {
          Swal.fire({ icon: 'error', title: 'Could not join', text: xhr.responseJSON?.message || 'Please try again.' });
        },
        complete: () => { this.joining = false; },
      });
    },
    format_type(value) {
      return String(value || '').replace(/_/g, ' ');
    },
    get_initials(organization) {
      return String(organization?.company_name || 'Organisation')
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(word => word.charAt(0).toUpperCase())
        .join('');
    },
  },
};
